import { apiClient } from "./apiClient";

export const WEBHOOK_EVENT_TYPES = [
  "template.created",
  "template.updated",
  "template.deleted",
  "generation.started",
  "generation.completed",
  "generation.failed",
  "migration.completed",
  "ai_quota.warning",
  "ai_quota.exceeded",
] as const;

export type WebhookEventType = (typeof WEBHOOK_EVENT_TYPES)[number];

export interface Webhook {
  id: string;
  url: string;
  events: WebhookEventType[];
  description?: string | null;
  active: boolean;
  created_at: string;
  updated_at: string;
}

export interface CreateWebhookInput {
  url: string;
  events: WebhookEventType[];
  description?: string;
  active?: boolean;
}

export interface CreatedWebhook extends Webhook {
  /** HMAC-SHA256 signing secret. Returned once on creation. */
  secret: string;
}

interface Wrapped<T> {
  data: T;
  meta?: Record<string, unknown>;
}

export async function listWebhooks(): Promise<Webhook[]> {
  const res = await apiClient.get<Wrapped<Webhook[]>>("/v1/webhooks");
  return res.data;
}

export async function createWebhook(input: CreateWebhookInput): Promise<CreatedWebhook> {
  const res = await apiClient.post<Wrapped<CreatedWebhook>>("/v1/webhooks", input);
  return res.data;
}

export async function deleteWebhook(id: string): Promise<void> {
  await apiClient.delete(`/v1/webhooks/${id}`);
}

export async function testWebhook(id: string): Promise<void> {
  await apiClient.post(`/v1/webhooks/${id}/test`);
}
